export const apiCallSuccess = 'COMPLETED';
export const apiCallError = 'ERROR';

export const apiCallSize = '100';

export const PROCESSING = 'processing';
export const UPLOADING = 'uploading';
export const READY = 'ready';
